import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import Header from '../adminComponents/header/Header';
import category from '../assets/dashboard/category.png';
import product from '../assets/dashboard/product.png';
import count from '../assets/dashboard/count.png';
import wporder from '../assets/dashboard/wporder.png';
import { countData } from '../services/User';

const Dashboard = () => {
  const [counts, setCounts] = useState({
    totalCategories: 0,
    totalCategoryItems: 0,
    users: 0,
    pendingOrders: 0
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const data = await countData();
        if (data && !data.error) {
          setCounts(data.data);
        }
      } catch (error) {
        console.error('Error fetching counts:', error);
      }
    };

    fetchCounts();
  }, []);

  const dashboardData = [
    {
      title: 'Total Categories',
      count: counts.totalCategories,
      description: 'Categories currently listed',
      icon: category,
      bgColor: '#E4E4FF'
    },
    {
      title: 'Total Products',
      count: counts.totalCategoryItems,
      description: 'Products currently listed',
      icon: product,
      bgColor: '#FEF2D6'
    },
    {
      title: 'Total Users',
      count: counts.users || 0,
      description: 'Registered users',
      icon: wporder,
      bgColor: '#D9F7E7'
    },
    {
      title: 'Pending Orders',
      count: counts.pendingOrders || 0,
      description: 'Orders awaiting approval',
      icon: count,
      bgColor: '#FFDED2'
    }
  ];

  return (
    <>
      <Header title="Dashboard" />
      <Box sx={{ pt: 3 }}>
        <Grid container spacing={2}>
          {dashboardData.map((item, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Card sx={{ boxShadow: '6px 6px 54px 0px #0000000D', borderRadius: '14px' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="h5" sx={{ color: '#202224' }}>
                        {item.title}
                      </Typography>
                      <Typography variant="h4" gutterBottom>
                        {item.count}
                      </Typography>
                    </Box>
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: item.bgColor,
                      borderRadius: '50px',
                      height: '60px',
                      width: '60px'
                    }}>
                      <img src={item.icon} alt={item.title} />
                    </Box>
                  </Box>
                  <Typography variant="body2" sx={{ color: '#1E2022', fontWeight: 600 }}>
                    {item.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Dashboard;